import { useTranslation } from 'react-i18next';

export function NotFoundErrorPage() {
  const { t } = useTranslation(['common', 'enumerations']);
  return <div>{t(`page_not_found`, { ns: 'common' })} </div>;
}
